/**
 * @flow
 * @relayHash e9e82f192f3486677c4021caf005a081
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type RightContainerQueryVariables = {|
  game_id: string
|};
export type RightContainerQueryResponse = {|
  +getGameDetails: ?{|
    +code: ?number,
    +message: ?string,
    +data: ?{|
      +_id: ?string,
      +game_settings: ?$ReadOnlyArray<?{|
        +active: ?boolean
      |}>,
    |},
  |}
|};
export type RightContainerQuery = {|
  variables: RightContainerQueryVariables,
  response: RightContainerQueryResponse,
|};
*/


/*
query RightContainerQuery(
  $game_id: ID!
) {
  getGameDetails(game_id: $game_id) {
    code
    message
    data {
      _id
      game_settings {
        active
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "game_id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "getGameDetails",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "game_id",
        "variableName": "game_id"
      }
    ],
    "concreteType": "front_game_type",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "code",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "message",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "data",
        "storageKey": null,
        "args": null,
        "concreteType": "game_details_data_type",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "_id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "game_settings",
            "storageKey": null,
            "args": null,
            "concreteType": "chapter_data_type",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "active",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "RightContainerQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "RightContainerQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "RightContainerQuery",
    "id": null,
    "text": "query RightContainerQuery(\n  $game_id: ID!\n) {\n  getGameDetails(game_id: $game_id) {\n    code\n    message\n    data {\n      _id\n      game_settings {\n        active\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f800094b7a1805cf3c33ec9693ce06c0';
module.exports = node;
